import { isExternal, useRouter } from '@/i18n/navigation'

import type { LinkEntry } from '../contentful/types'
import type { DynamicIntlHref } from '../contentful/utils'
import { getLinkEntryUrl } from '../contentful/utils'
import { useLocale } from '../locale'

export const useNavigate = () => {
  const router = useRouter()
  const locale = useLocale()

  const navigate = (linkParams: Pick<LinkEntry, 'page' | 'url'>) => {
    const url = getLinkEntryUrl(linkParams, locale)
    if (typeof url === 'string' && isExternal(url)) {
      location.assign(url)
    } else {
      router.push(url as DynamicIntlHref)
    }
  }

  return { navigate }
}
